Ext.define('PanelWizardFilterTypyWlasnosci', {
    extend: 'Ext.panel.Panel',
    initComponent: function () {
        this.cid = Ext.id();
        Ext.apply(this, {
            layout: "fit",
            frame: false,
            border: false,
            autoWidth: false,
            autoHeight: false,
            items: [{
                xtype: 'form',
                frame: false,
                border: false,
                autoWidth: true,
                autoHeight: true,
                bodyStyle: 'padding:10px 10px 10px 10px',
                defaults: {
                    anchor: "0"
                },
                id: this.cid + "formpanel",
                labelWidth: 100,
                items: [{
                    anchor: "0",
                    layout: 'column',
                    frame: false,
                    border: false,
                    items: [{
                        columnWidth: 1.0,
                        layout: 'form',
                        labelWidth: 100,
                        defaults: {
                            anchor: "0"
                        },
                        frame: false,
                        border: false,
                        items: [{
                            id: this.cid + "WLASNY",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.typy_wlasnosci[0].capitalise()
                        }, {
                            id: this.cid + "WYNAJEM",
                            value: true,
                            xtype: 'checkboxexd',
                            hideLabel: true,
                            boxLabel: LangComp.typy_wlasnosci[1].capitalise()
                        }]
                    }]
                }]
            }]
        });
        this.callParent(arguments);
    },
    callAfterShow: function () {
        var t0 = Ext.getCmp(this.cid + "WLASNY");
        var t1 = Ext.getCmp(this.cid + "WYNAJEM");
        var bbem = this.datad.mainCtrl.repDef.typyWlasnosci.length == 0;
        t0.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyWlasnosci, Const.TYP_WLASNOSCI_POJAZDU_WLASNY) || bbem);
        t1.setValue(Ext.Array.contains(this.datad.mainCtrl.repDef.typyWlasnosci, Const.TYP_WLASNOSCI_POJAZDU_WYNAJEM) || bbem);

        this.callAfterShowCalled = true;
    },
    callAfterHide: function () {
        if (this.callAfterShowCalled) {
            var t0 = Ext.getCmp(this.cid + "WLASNY");
            var t1 = Ext.getCmp(this.cid + "WYNAJEM");
            this.datad.mainCtrl.repDef.typyWlasnosci = [];
            if (t0.getValue())
                this.datad.mainCtrl.repDef.typyWlasnosci.push(Const.TYP_WLASNOSCI_POJAZDU_WLASNY);
            if (t1.getValue())
                this.datad.mainCtrl.repDef.typyWlasnosci.push(Const.TYP_WLASNOSCI_POJAZDU_WYNAJEM);
        }
        return null;
    },
    setData: function (datad) {
        this.datad = datad;
    }
});
